import {
  FULLSCREEN_TABLES,
  useFullScreenModeEnabled
} from "../../store/model-misc";
import { useTableName } from "./my-ag-grid-react-context";

export function useGridBorderRadius() {
  const fullScreen = useFullScreenModeEnabled();
  const tableName = useTableName();
  return fullScreen && FULLSCREEN_TABLES.has(tableName) ? "0" : "4px";
}
